import axios from "axios";

class MyFinanceService {
  static baseUrl = "https://app.myfinance.com.br";

  async acquireAccounts(token) {
    const authorizationToken = `Basic ${window.btoa(token)}`;
    const config = {
      headers: {
        Authorization: authorizationToken
      }
    };

    let response, success;

    try {
      response = await axios.get(
        `${MyFinanceService.baseUrl}/accounts.json`,
        config
      );
      success = true;
    } catch (e) {
      response = e.response;
      success = false;
    }

    const fatal = !response;
    const data = fatal ? null : response.data;
    const headers = fatal ? null : response.headers;

    return { fatal, data, headers, success };
  }

  async acquireEntities(token, accountId) {
    const authorizationToken = `Basic ${window.btoa(token)}`;
    const config = {
      headers: {
        Authorization: authorizationToken,
        ACCOUNT_ID: accountId
      }
    };

    let response, success;

    try {
      response = await axios.get(
        `${MyFinanceService.baseUrl}/entities.json`,
        config
      );
      success = true;
    } catch (e) {
      response = e.response;
      success = false;
    }

    const fatal = !response;
    const data = fatal ? null : response.data;
    const headers = fatal ? null : response.headers;

    return { fatal, data, headers, success };
  }
}

export default new MyFinanceService();



// WEBPACK FOOTER //
// ./src/components/app/registration/company/view/integrations/my-finance/my-finance.service.js